import React, { useContext, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Banner from "../../components/Banner";
import Categories from "../../components/Categories";
import CategoryFeatured from "../../components/CategoryFeatured";
import HelmetCustom from "../../components/HelmetCustom";
import ItemList from "../../components/ItemList";
import MainLayout from "../../components/MainLayout";
import { Creators as ProductsActions } from "../../store/ducks/products";
import { Container } from "./styles";
import Loading from "../../components/Loading";
import api from '../../services/api';
import { OrdenationContext } from "../../contexts/OrdenationContext";

export default function Main({ history }) {
  const dispatch = useDispatch();
  const { setOrdenations, } = useContext(OrdenationContext);
  const { data: products, loading, hasMore } = useSelector(
    state => state.products
  );
  const selectedStoreUuid = useSelector(state => state.storeByUser.data?.uuid);
  const { data } = useSelector(state => state.store);
  const [categoriesWithHighlightImage, setCategoriesWithHighlightImage] = useState([]);

  useEffect(() => {
    getCategoriesWithHighlightImage();
  }, []);

  useEffect(() => {
    dispatch(ProductsActions.resetOffset());
    setOrdenations('relevancia');
    dispatch(ProductsActions.getProductsRequest());
  }, [dispatch, selectedStoreUuid]);


  function loadMore() {
    dispatch(ProductsActions.getProductsRequest());
  }

  const getCategoriesWithHighlightImage = async () => {
    try {
      const response = await api.get('categories/highlight-images')
      if (response.status === 200) {
        setCategoriesWithHighlightImage(response.data)
      } else {
        setCategoriesWithHighlightImage([])
      }
    } catch (err) {
      console.log(err)
      setCategoriesWithHighlightImage([])
    }
  }



  return (
    <>
      {data && data.empresa ? (
        <MainLayout history={history}>
          <Container>
            <HelmetCustom />
            <Banner />
            <Categories />
            <div className="products">
              <ItemList
                products={products}
                hasMore={hasMore}
                loadMore={loadMore}
                loading={loading}
                columns={5}
              />
            </div>
            {categoriesWithHighlightImage && categoriesWithHighlightImage.map((highlight) => (
              <CategoryFeatured key={highlight.id} category={
                {
                  id: highlight.id,
                  type: highlight.tipo,
                  description: highlight.nome,
                  url: highlight.url,
                  customLink: highlight.link_personalizado_rodape,
                  openInNewTab: highlight.nova_aba_rodape,
                  image1: highlight.base64Imagem,
                  image2: highlight.base64Imagem2
                }
              } />
            ))}
          </Container>
        </MainLayout>
      ) : <Loading />}
    </>
  );
}
